import { i18nKeys } from 'translationTypes'
import i18n from '../../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.deliveryIssueExplanation_title),
  body: () => i18n.t(i18nKeys.deliveryIssueExplanation_body),
  deactivationPolicy: () =>
    i18n.t(i18nKeys.deliveryIssueExplanation_link_deactivation_policy),
  criticalDeliveryIssuesFaq: () =>
    i18n.t(i18nKeys.deliveryIssueExplanation_link_critical_delivery_issues_faq),
  customerUnavailableFaq: () =>
    i18n.t(i18nKeys.deliveryIssueExplanation_link_customer_unavailable_faq),
  icAgreement: () =>
    i18n.t(i18nKeys.deliveryIssueExplanation_link_ic_agreement),
  extremeLatenessFaq: () =>
    i18n.t(i18nKeys.deliveryIssueExplanation_link_extreme_lateness_faq),
}
